<template>
  <div class="link-views no-bg">
    <div class="message-div">
      <div class="select-div">
        <div class="mr">
          <span>选择实验：</span>
          <i-select style="width:200px" v-model="pageData.ExpId">
            <i-option
              v-for="item in virtualList"
              :value="item.ExpID"
              :key="item.ExpID"
            >{{ item.ExpName }}</i-option>
          </i-select>
        </div>
        <div>
          <Button
            type="primary"
            class="mr"
            icon="md-search"
            @click="sureSearch(pageData.ExpId,1)"
          >查询</Button>
          <Button type="primary" icon="md-refresh" @click="sureSearch(0,1)">重置</Button>
        </div>
      </div>
      <!-- 留言内容列表 -->
      <div class="bg-div">
        <div v-if="ExpTalkList.Result.length>0" class="messageBox">
          <div class="messageFlex" v-for="(item,index) in ExpTalkList.Result" :key="index">
            <div class="sideLeft">{{item.TalkName}}</div>
            <div class="item">
              <!-- 主留言 -->
              <div class="messageFlex">
                <div class="item">
                  <div style="color:#666;font-size: 14px;">{{item.ExpName}}</div>
                  <br>
                  <div>{{item.Content}}</div>
                </div>
                <div class="text-right">
                  <div style="color:#999;font-size: 12px;">{{item.TalkTime}}</div>
                  <div>
                    <a @click="reply(item.ExpTalkId,item.ExpTalkReId,item.TalkName)">回复</a>
                  </div>
                </div>
              </div>

              <div v-if="item.Result.length>0">
                <div v-for="(obj,n) in item.Result" :key="n" class="replyResult">
                  <div class="item">
                    <div class="replyUserName">{{obj.UserName}}</div>
                    <div>
                      <span style="color:#666;padding-right:10px;">回复</span>
                      <span class="theme">{{obj.ReName}}：</span>
                      {{obj.ReContent}}
                    </div>
                  </div>
                  <div class="text-right">
                    <div style="color:#999;font-size: 12px;line-height:20px;">{{obj.ReTime}}</div>
                    <div>
                      <a @click="reply(item.ExpTalkId,obj.ReviewId,obj.UserName)">回复</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="nodata">暂无数据</div>
        <!-- 分页 -->
        <div class="page-div">
          <Page
            show-total
            :total="ExpTalkList.records"
            :current="pageData.page"
            :page-size="pageData.size"
            @on-change="changePage"
          />
        </div>
      </div>

      <!-- 添加留言 -->
      <div class="bg-div">
        <Form ref="submitItem" :model="submitItem" :rules="ruleValidate" :label-width="96">
          <FormItem label="选择实验：" prop="ExpId">
            <i-select style="width:200px" v-model="submitItem.ExpId">
              <i-option
                v-for="item in virtualList"
                :value="item.ExpID"
                :key="item.ExpID"
              >{{ item.ExpName }}</i-option>
            </i-select>
          </FormItem>
          <FormItem prop="Content" :label-width="0">
            <Input placeholder="请在这里添加回复" type="textarea" v-model="submitItem.Content"/>
          </FormItem>
          <FormItem class="text-right">
            <Button type="primary" @click="handleSubmit('submitItem')">发布</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
 import * as publicApi from "../../../api/public-api.js";
export default {
  name: "Message",
  data() {
    return {
      virtualList: [], //所有实验列表
      ExpTalkList: { Result: [] },
      pageData: {
        ExpId: 0,
        page: 1,
        size: 10
      },
      submitItem: {}, //发布留言列表
      ruleValidate: {
        ExpId: [
          {
            required: true,
            message: "实验名称不能为空",
            type: "number",
            trigger: "change"
          }
        ],
        Content: [
          {
            required: true,
            message: "请填写留言内容",
            trigger: "blur"
          }
        ]
      },
      value: "",
      replyTalk: {}
    };
  },
  mounted() {
    // this.GetvirtualList();
    this.GetExpTalkList();
  },
  methods: {
    // 获取所有实验列表
    // async GetvirtualList() {
    //   this.virtualList = await publicApi.GetArrExp({
    //     Search: ""
    //   });
    // },
    // 查看所有留言
    async GetExpTalkList() {
      this.ExpTalkList = await publicApi.GetExpTalkList({
        ExpId: this.pageData.ExpId ? this.pageData.ExpId : 0,
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 10
      });
    },
    // 添加留言
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          publicApi.AddExpTalk(this.submitItem).then(res => {
            if (res.success) {
              this.submitItem = {};
              this.changePage(1);
              this.$refs["submitItem"].resetFields();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    },
    //回复留言按钮
    reply(ExpTalkId, ExpTalkReId, ReForMan) {
      this.$Modal.confirm({
        render: h => {
          return h("Input", {
            props: {
              value: this.value,
              autofocus: true,
              placeholder: "回复留言...",
              type:"textarea",
              rows:5
            },
            on: {
              input: val => {
                this.value = val;
                this.replyTalk.ExpTalkId = ExpTalkId;
                this.replyTalk.ExpTalkReId = ExpTalkReId;
                this.replyTalk.ReForMan = ReForMan;
                this.replyTalk.Content = val;
              }
            }
          });
        },
        onOk: () => {
          publicApi.AddTalkRe(this.replyTalk).then(res => {
            if (res.success) {
              this.value = "";
              this.replyTalk = {};
              this.GetExpTalkList();
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        },
        onCancel: () => {
          this.value = "";
          this.replyTalk = {};
        }
      });
    },
    sureSearch(ExpId, page) {
      this.pageData.ExpId = ExpId;
      this.pageData.page = page;
      this.GetExpTalkList();
    },
    changePage(page) {
      this.pageData.page = page;
      this.GetExpTalkList();
    } 
  }
};
</script>

<style scoped>
</style>